import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import userSlice from "../features/user/userSlice";
import drawerSlice from "../components/drawer/drawerSlice";
import menuSlice from "../features/menu/menuSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import inquirySlice from "../features/inquiry/inquirySlice";
import cmsSlice from "../features/cms/cmsSlice";
import seotagSlice from "../features/seotag/seotagSlice";
import testimonialSlice from "../features/testimonial/testimonialSlice";
import blogSlice from "../features/blog/blogSlice";
import faqSlice from "../features/faq/faqSlice";
import bannerSlice from "../features/banner/bannerSlice";
import rightsSlice from "../features/rights/rightsSlice";
import loginSlice from "../features/login/loginSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import settingSlice from "../features/setting/settingSlice";
import facilitySlice from "../features/facility/facilitySlice";
import whychooseSlice from "../features/whychoose/whychooseSlice";
import amenitiesSlice from "../features/amenities/amenitiesSlice";
import tourtypeSlice from "../features/tourtype/tourtypeSlice";
import activitySlice from "../features/activities/activitiesSlice";
import gallerySlice from "../features/gallery/gallerySlice";
import roomSlice from "../features/room/roomSlice";
import attractionsSlice from "../features/attraction/attractionsSlice";

const store = configureStore({
  reducer: {
    dialog: dialogSlice,
    drawer: drawerSlice,
    user: userSlice,
    menu: menuSlice,
    userType: userTypeSlice,
    inquiry: inquirySlice,
    cms: cmsSlice,
    banner: bannerSlice,
    faq: faqSlice,
    blog: blogSlice,
    testimonial: testimonialSlice,
    seotag: seotagSlice,
    rights: rightsSlice,
    login: loginSlice,
    pagination: paginationSlice,
    setting: settingSlice,
    facility: facilitySlice,
    whychoose: whychooseSlice,
    amenities: amenitiesSlice,
    tourtype: tourtypeSlice,
    activity: activitySlice,
    gallery: gallerySlice,
    room: roomSlice,
    attractions: attractionsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
